import { render, staticRenderFns } from "./AddonsManage.vue?vue&type=template&id=69b5d31e&scoped=true&"
import script from "./AddonsManage.vue?vue&type=script&lang=js&"
export * from "./AddonsManage.vue?vue&type=script&lang=js&"
import style0 from "./AddonsManage.vue?vue&type=style&index=0&id=69b5d31e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b5d31e",
  null
  
)

export default component.exports